import { render, staticRenderFns } from "./manual-tab.vue?vue&type=template&id=c27c31c0"
import script from "./manual-tab.vue?vue&type=script&lang=js"
export * from "./manual-tab.vue?vue&type=script&lang=js"
import style0 from "./manual-tab.vue?vue&type=style&index=0&id=c27c31c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports